




























































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ClientModule from '@/stores/modules/ClientModule';
import InputRulesHelper from '@/helpers/InputRulesHelper';

@Component
export default class ClientInformation extends Vue {
  public clientModule: ClientModule = getModule(ClientModule);

  public readonly inputRules: InputRulesHelper = new InputRulesHelper();

  public get clientInformationValidated() {
    return this.clientModule.clientInformationValidated;
  }

  public set clientInformationValidated(isValidated: boolean) {
    this.clientModule.setClientInfoValidated({
      isValidated,
      clientScreen: 'clientInformationValidated',
    });
  }

  public handleInput(value: string | number, type: string): void {
    this.clientModule.setClient({
      ...this.clientModule.client,
      [type]: value,
    });
  }
}
